import React from 'react';

const TM = () => <sup>™</sup>;

const Waypoints = () => {
    return (
        <div style={{ paddingLeft: '16px' }}>
            <h1>Mapping EZ<TM /></h1>
        </div>
    );
};

export default Waypoints;